export default __webpack_public_path__ + "static/media/lab.3638069c.png";